import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import {
  DisableOfficeField,
  DisableVendorField,
  officeVendorAddState,
  officeVendorEditState,
  ovsFromOffice,
  rowForEditOfficeSettings,
  resetOfficeVendorForm,
} from "../atoms/atoms";
import { IOfficeDetails } from "../types";
import { toast } from "../../../../components/toastNotification";
import { useServiceProvided } from "../hooks/useGetServiceProvided";
import { useSFGetOffice } from "../hooks/useSFGetOffice";
import SubmitHookForm from "../../../../components/SubmitHookForm";
import CancelButton from "../../../../components/CancelButton";
import useAddOfficeVendorService from "../hooks/useAddOfficeVendorService";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import { useQueryClient } from "react-query";
import useEditOfficeVendorService from "../hooks/useEditOfficeVendorService";
import CheckBoxHookForm_2 from "../../../../components/CheckBoxHookForm_2";
import { entityEIN, vendorServiceId } from "../../Vendor/atoms/atoms";
import useVendor from "../../Vendor/hooks/useVendor";
interface OfficeVendorServiceProps {
  data: any;
}
const OfficeVendorServiceForm: React.FC<OfficeVendorServiceProps> = ({
  data,
}) => {
  const queryClient = useQueryClient();
  const [newData, setNewData] = useState<IOfficeDetails>();
  const [isAddState, setAddState] = useRecoilState(officeVendorAddState);
  const [isEditState, setEditState] = useRecoilState(officeVendorEditState);
  const [rowForEdit, setRowToEdit] = useRecoilState(rowForEditOfficeSettings);
  const isResetOfficeVendorForm = useRecoilValue(resetOfficeVendorForm);
  const [isSaving, setIsSaving] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [disableOfficeField, setDisableOfficeField] =
    useRecoilState(DisableOfficeField);
  const [disableVendorField, setDisableVendorField] =
    useRecoilState(DisableVendorField);
  const [vendorId, setVendorId] = useRecoilState(vendorServiceId);
  const entityEin = useRecoilValue(entityEIN);
  const useFormMethods = useForm<any>({
    defaultValues: { ...rowForEdit },
  });
  const fromOffice = useRecoilValue(ovsFromOffice);
  const {
    formState: { isDirty },
    setValue,
    register,
    watch,
  } = useFormMethods;

  const {
    mutate: addOfficeVendorService,
    isSuccess: addSuccess,
    isError: addError,
    data: addResult,
    reset: resetAddData,
  } = useAddOfficeVendorService();

  //Edit Security Initialization/
  const {
    mutate: editOfficeVendorService,
    isSuccess: editSuccess,
    isError: editError,
    data: editResult,
    reset: resetEditData,
  } = useEditOfficeVendorService();

  useEffect(() => {
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setRowToEdit(undefined);
  }, [isResetOfficeVendorForm]);

  const handleCancel = () => {
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setRowToEdit(undefined);
    setAddState(false);
    setEditState(false);
    setIsSaving(false);
    setDisableVendorField(false);
    setDisableOfficeField(false);
    setVendorId(undefined);
  };

  const { data: Vendors } = useVendor();

  const vendorsOption = Vendors?.map(
    (x: {
      id: number;
      name: string;
      contact: string;
      email: string;
      city: string;
      accountNumber: string;
      state: string;
      street: string;
      vendorType: number;
      vendorTypeName: string;
      zipcode: string;
      phone: string;
      tonerRequestEmail: string;
      tonerRequestPhone: string;
      isInActive: string;
      vendorCode: string;
    }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.name,
        email: x.email,
        accountNumber: x.accountNumber,
        address:
          (x.street ? x.street : "") +
          " " +
          (x.city ? x.city : "") +
          " " +
          (x.state ? x.state : "") +
          " " +
          (x.zipcode ? x.zipcode : ""),
        vendorType: x.vendorType,
        vendorPhone: x.phone,
        trEmail: x.tonerRequestEmail,
        tonerPhone: x.tonerRequestPhone,
        contact: x.contact,
        inactiveAccount: x.isInActive ? "True" : "False",
        vendorTypeName: x.vendorTypeName,
        vendorCode: x.vendorCode,
      };
    }
  );

  // const { data: offices } = useOfficesForSecurity();
  // const sfOfficeNameOpt = offices?.data?.map((x) => {
  //   return {
  //     value: x.officeId,
  //     label: x.officeName,
  //     officeStatus: x.officeStatus,
  //     officeState: x.officeState,
  //     officeBrand: x.officeBrand,
  //   };
  // });
  const glData = (glNumber, glEntityName) => {
    if (!glNumber && !glEntityName) {
      return "";
    }
    if (glNumber && glEntityName) {
      const gl = `${glNumber} - ${glEntityName}`;
      return gl;
    }

    if (glNumber) {
      return glNumber;
    }
    if (glEntityName) {
      return glEntityName;
    }
    return "";
  };

  const { data: agencies } = useSFGetOffice();
  const sfOfficeNameOpt = agencies?.map((x) => {
    const branchGl = glData(x.glNumber, x.glEntityName);
    return {
      name: x.businessOperation,
      id: x.officeCode,
      value: x.officeId,
      label: x.officeName,
      entityEin: x.entityEIN,
      branchGL: branchGl,
      subAccount: x.subAccount,
    };
  });
  const { data: serviceProvided } = useServiceProvided();
  const serviceProvidedOpt = serviceProvided?.data?.map((x) => {
    return {
      value: x.id,
      label: x.servicesProvided1,
      typeId: x.vendorTypeId,
    };
  });

  // services options
  const filteredProvidedOpt = serviceProvidedOpt?.filter(
    (x) => x.typeId === watch("vendorTypeId")
  );

  const handleSave = () => {
    setSaveModal(false);
    if (isAddState) {
      addOfficeVendorService(newData);
    } else {
      editOfficeVendorService(newData);
      // if (isLinkedState) {
      //   setTimeout(() => handleLink(), 5000);
      // }
    }
  };

  if (addSuccess && addResult) {
    if (addResult.status === 501) {
      toast.fire(
        "Failed",
        "Office vendor service record already exists.",
        "error"
      );
      setIsSaving(!isSaving);
      setSaveModal(false);
    } else if (addResult.status === 201 || addResult.status === 200) {
      toast.fire(
        "Success",
        "Office vendor service added successfully.",
        "success"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
      queryClient.invalidateQueries("GetScoreCard");
      queryClient.invalidateQueries("GetVendorOffices");
      //ssearchRefetch();
      handleCancel();
      setAddState(false);
    } else if (addResult.status === 500) {
      if (
        addResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        addResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "New office vendor service added successfully, but " +
            addResult.data.message,
          "warning"
        );
        handleCancel();
      } else {
        toast.fire(
          "Failed",
          "Failed to add office vendor Service! No data saved.",
          "error"
        );
      }
      queryClient.invalidateQueries("GetScoreCard");
      queryClient.invalidateQueries("GetVendorOffices");
      setAddState(false);
    } else {
      toast.fire(
        "Server Error",
        "Failed to add office vendor service! No data saved.",
        "error"
      );
      queryClient.invalidateQueries("GetScoreCard");
      queryClient.invalidateQueries("GetVendorOffices");
      setAddState(false);
    }
    resetAddData();
    setSaveModal(false);
    setIsSaving(false);
  }
  if (addError) {
    setIsSaving(false);
    setSaveModal(false);
    toast.fire(
      "Server Error",
      "Failed to add office vendor service! No data saved.",
      "error"
    );
    queryClient.invalidateQueries("GetScoreCard");
    queryClient.invalidateQueries("GetVendorOffices");
    setAddState(false);
  }

  //Edit result
  if (editSuccess && editResult) {
    if (editResult && editResult.status === 501) {
      toast.fire(
        "Failed",
        "Office vendor service record already exists.",
        "error"
      );
      setIsSaving(!isSaving);
      setSaveModal(false);
    } else if (
      (editResult && editResult.status === 201) ||
      editResult.status === 200
    ) {
      toast.fire(
        "Success",
        "Office vendor service updated successfully.",
        "success"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data.officeId
      );
      queryClient.invalidateQueries("GetVendorOffices");
      //searchRefetch();
      handleCancel();
      setRowToEdit(undefined);
      setEditState(false);
    } else if (editResult.status === 500) {
      if (
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "New office vendor service updated successfully, but " +
            editResult.data.message,
          "warning"
        );
        setIsSaving(false);
        handleCancel();
        setRowToEdit(undefined);
        setDisableVendorField(false);
        setDisableOfficeField(false);
      } else {
        setIsSaving(false);
        setRowToEdit(undefined);
        toast.fire(
          "Failed",
          "Failed to update office vendor service! No data saved.",
          "error"
        );
      }
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data.officeId
      );
      queryClient.invalidateQueries("GetVendorOffices");
      setEditState(false);
    } else {
      toast.fire(
        "Server Error",
        "Failed to update office vendor service! No data saved.",
        "error"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data.officeId
      );
      queryClient.invalidateQueries("GetVendorOffices");
      setEditState(false);
    }
    resetEditData();
  }
  if (editError) {
    setIsSaving(false);
    setSaveModal(false);
    setEditState(false);
    toast.fire(
      "Server Error",
      "Failed to update office vendor service! No data saved.",
      "error"
    );
    queryClient.invalidateQueries(
      "GetOfficeVendorServiceByOfficeId",
      data.officeId
    );
    queryClient.invalidateQueries("GetVendorOffices");
    setEditState(false);
  }

  const updateBranchGL = (data: any) => {
    if (
      data?.glBranch === null &&
      data?.glBranch === 401 &&
      data.glEntityName !== null
    ) {
      return data.glEntityName ?? "";
    }
    if (data?.glBranch !== null && data.glBranch !== 401) {
      if (data?.glEntityName !== null) {
        const glBranch = data?.glBranch ? data?.glBranch : null;
        const glEntity = data?.glEntityName ? data?.glEntityName : null;
        const dash = glBranch && glEntity ? " - " : "";
        const gl = `${glBranch ?? ""}${dash}${glEntity ?? ""}`;
        return `${gl}`;
      }
      return `${data.glBranch ?? ""}`;
    }

    return null;
  };

  useEffect(() => {
    if (isAddState) {
      const subAccount = agencies?.find((x) => x.officeId === data.officeId);
      useFormMethods.setValue("officeId", data.officeId);
      useFormMethods.setValue("vendorId", vendorId?.id);
      setValue("vendorCode", vendorId?.vendorCode);
      setValue("vendorTypeId", vendorId?.vendorType);
      setValue("inactiveAccount", vendorId?.isInActive);
      setValue("contact", vendorId?.contact);
      setValue("phone", vendorId?.phone);
      setValue("vendorTypeName", vendorId?.vendorTypeName);
      setValue("w9", entityEin);
      const branchGL = updateBranchGL(data);
      setValue("branchGL", branchGL);
      setValue("glsubaccounts", subAccount?.subAccount);
    }
    if (isEditState) {
      //useFormMethods.setValue("vendorId", vendorId?.id);
    }
  }, []);

  const onSubmit = (data: IOfficeDetails) => {
    let vendor = "Vendor";
    let office = "Office";
    setNewData({
      ...data,
      fromModule: fromOffice ? office : vendor,
    });
    if (isAddState) {
      setSaveModal(true);
    } else if (isEditState && isDirty) {
      setSaveModal(true);
    } else {
      setIsSaving(false);
      if (!isDirty) {
        toast.fire("Saving Failed", "No changes have been made.", "warning");
      }
    }
  };

  return (
    <>
      {/* inline-block overflow-visible text-left align-left transition-all transform bg-white brContainer opacity-100 scale-100 */}
      <div className="  text-left align-left transition-all transform bg-white brContainer opacity-100 scale-100 p-1 ">
        <FormProvider {...useFormMethods}>
          <form onSubmit={useFormMethods.handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center">
              <div className="flex flex-row  justify-between items-center text-primary font-bold font-sans text-lg pb-1">
                {isAddState ? "Add " : "Edit "}Office Vendor Service
              </div>
              <div className="flex justify-between gap-2 pb-2">
                <SubmitHookForm
                  type="submit"
                  disabled={isSaving}
                  buttonText={isSaving ? "Saving.." : "Save"}
                  className={undefined}
                  onClick={undefined}
                />
                <CancelButton
                  onClick={() => {
                    // ev.preventDefault();
                    handleCancel();
                  }}
                />
              </div>
            </div>
            <div className="w-full border-b-2 border-secondary" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 my-4 pt-1">
              <div className="grid-cols-1">
                <div className="space-y-1">
                  {isEditState && (
                    <span className="flex justify-end -mt-2">
                      {useFormMethods.watch("inactiveAccount") === "True" && (
                        <span className="text-xs text-red-600 italic">
                          Vendor selected is Inactive.
                        </span>
                      )}
                    </span>
                  )}
                  <Controller
                    control={useFormMethods.control}
                    name="vendorId"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        onChange={(e) => {
                          setValue("vendorTypeId", e ? e.vendorType : "");
                          setValue("vendorTypeName", e ? e.vendorTypeName : "");
                          field.onChange(e ? e.value : null);
                          setValue(
                            "inactiveAccount",
                            e ? e.inactiveAccount : ""
                          );
                          setValue("contact", e ? e.contact : "");
                          setValue("phone", e ? e.vendorPhone : "");
                          setValue("vendorCode", e ? e.vendorCode : "");
                          setValue("servicesProvidedId", null);
                        }}
                        className={
                          useFormMethods.formState.errors.vendorId &&
                          "border-2 border-red-500 col-span-2 "
                        }
                        value={field.value}
                        options={vendorsOption}
                        isLoading={false}
                        required={true}
                        label="Vendor Name"
                        isDisabled={disableVendorField ? true : false}
                      />
                    )}
                  />
                  <TextInputHookFormDisabled
                    name="vendorCode"
                    label="Vendor Code"
                    type="text"
                    register={register("vendorCode", {})}
                  />
                  <Controller
                    control={useFormMethods.control}
                    name="officeId"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                          useFormMethods.setValue("w9", e.entityEin);
                          setValue("branchGL", e.branchGL);
                          setValue("glsubaccounts", e.subAccount);
                        }}
                        value={field.value}
                        className={
                          useFormMethods.formState.errors.officeId &&
                          "border-2 border-red-500 col-span-2 "
                        }
                        options={sfOfficeNameOpt}
                        isLoading={false}
                        required={true}
                        label="Office"
                        isDisabled={disableOfficeField ? true : false}
                      />
                    )}
                  />

                  <TextInputLabelHookForm
                    name="accountNumber"
                    label="Account Number"
                    type="text"
                    required={false}
                    className={
                      useFormMethods.formState.errors.accountNumber &&
                      useFormMethods.formState.errors.accountNumber.message &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    register={register("accountNumber", {})}
                    maxLength={50}
                  />
                  <TextInputLabelHookForm
                    name="bankAccount"
                    label="Bank Account"
                    type="text"
                    required={false}
                    className={
                      useFormMethods.formState.errors.bankAccount &&
                      useFormMethods.formState.errors.bankAccount.message &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    register={register("bankAccount", {})}
                    maxLength={4}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <TextInputHookFormDisabled
                    name="contact"
                    label="Contact"
                    type="text"
                    register={register("contact", {})}
                  />
                  <TextInputHookFormDisabled
                    name="phone"
                    label="Phone"
                    type="text"
                    required={false}
                    className={""}
                    register={register("phone", {})}
                    maxLength={15}
                  />

                  <TextInputLabelHookForm
                    name="meterNumber"
                    label="Meter Number"
                    type="text"
                    required={false}
                    className={
                      useFormMethods.formState.errors.meterNumber &&
                      useFormMethods.formState.errors.meterNumber.message &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    register={register("meterNumber", {})}
                    maxLength={30}
                  />
                </div>
              </div>
              <div className="space-y-1">
                <div className="space-y-1">
                  <TextInputHookFormDisabled
                    name="vendorTypeName"
                    label="Vendor Type Name"
                    type="text"
                    register={register("vendorTypeName", {})}
                  />
                  <Controller
                    name="servicesProvidedId"
                    control={useFormMethods.control}
                    rules={{ required: false }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                        }}
                        value={field.value}
                        options={filteredProvidedOpt}
                        label="Services Provided"
                        className={""}
                        required={false}
                      />
                    )}
                  />
                  <TextInputLabelHookForm
                    name="invoiceAvailabilityDay"
                    label="Invoice Availability Day"
                    type="text"
                    required={false}
                    className={
                      useFormMethods.formState.errors.invoiceAvailabilityDay &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    register={register("invoiceAvailabilityDay", {})}
                    maxLength={50}
                  />
                  <TextInputLabelHookForm
                    name="branchGL"
                    label="Branch GL"
                    type="text"
                    required={false}
                    register={register("branchGL", {})}
                    disabled={true}
                  />
                  <TextInputLabelHookForm
                    name="glsubaccounts"
                    label="Subaccounts"
                    type="text"
                    required={false}
                    pattern="\d{2}-\d{3}-\d{6}-\d{2}"
                    placeholder="00-000-000000-00"
                    onChange={(e) => {
                      if (e.target.value) {
                        var x = e.target.value
                          .replace(/\D/g, "")
                          .match(/(\d{0,2})(\d{0,3})(\d{0,6})(\d{0,2})/);
                        if (x) {
                          e.target.value = !x[2]
                            ? x[1]
                            : x[1] +
                              "-" +
                              x[2] +
                              (x[3] ? "-" + x[3] : "") +
                              (x[4] ? "-" + x[4] : "");
                        }
                      } else {
                        setValue("glsubaccounts", "");
                      }
                    }}
                    className={
                      useFormMethods.formState.errors.glsubaccounts &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    register={register("glsubaccounts", {})}
                    maxLength={30}
                    // disabled={true}
                  />
                  <TextInputHookFormDisabled
                    name="w9"
                    label="W9"
                    type="text"
                    required={false}
                    className={
                      useFormMethods.formState.errors.w9 &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    register={register("w9", {})}
                    maxLength={50}
                  />
                  <CheckBoxHookForm_2
                    name="isActive"
                    label="Is Active"
                    type="checkbox"
                    validation={{
                      required: {
                        value: false,
                        message: "Required Field",
                      },
                    }}
                    disabled={false}
                    className={undefined}
                    register={register}
                    hasPermission={undefined}
                  />
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>

      {saveModal && (
        <ConfirmBoxModal
          ModalTitle={
            isAddState
              ? "Add Office Vendor Service"
              : "Edit Office Vendor Service"
          }
          qConfirmation={`Are you sure you want to ${
            isAddState ? "Add " : "Update "
          } this data?`}
          isOpen={saveModal}
          onClose={() => {
            setSaveModal(false);
            setIsSaving(false);
          }}
          onClickFunction={() => {
            handleSave();
            setIsSaving(true);
          }}
          cancelButtonRef={undefined}
        />
      )}
    </>
  );
};

export default OfficeVendorServiceForm;
